const SettingsInput = ({ 
  type = 'text',
  value, 
  onChange, 
  placeholder = '',
  disabled = false,
  className = ''
}) => {
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      className={`
        w-[194px] h-[24px] border border-border-default rounded
        px-spacing-2 py-spacing-1 bg-bg-input text-[14px] text-primary 
        placeholder:text-secondary/50 
        focus:border-accent focus:outline-none 
        transition-colors
        ${type === 'password' ? 'font-mono' : ''}
        ${className}
      `}
    />
  );
};

export default SettingsInput;
